export default __webpack_public_path__ + "static/media/IONNYK-discovery wall website.e5074a91.jpeg";